import { useHistory } from "react-router";

import { useCompanyContext } from "Bands/contexts";
import { buildUrl } from "shared/utils";
import { BAND_PATHS } from "../../router/constants";
import { useCallback } from "react";

export const useCompanyRoute = () => {
  const history = useHistory();
  const { companyId } = useCompanyContext();

  const pushRoute = useCallback(
    (path: string, options?: { companyId?: string; hash?: string }) => {
      (companyId || options?.companyId) &&
        history.push(
          buildUrl(path, { companyId: (options?.companyId || companyId) as string }, options?.hash)
        );
    },
    [companyId, history]
  );

  const getPath = useCallback(
    (path: string, options?: { companyId?: string; type?: string; hash?: string }) => {
      if (companyId || options?.companyId) {
        return buildUrl(
          path,
          {
            companyId: (options?.companyId || companyId) as string,
            type: options?.type as string,
          },
          options?.hash
        );
      }
      return BAND_PATHS.HOME;
    },
    [companyId]
  );

  return { pushRoute, getPath };
};
